export default function CategoryGrid() {
  const smallCategories = [
    {
      name: "Sets",
      url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
      image: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20fashion%20set%20outfit%20laid%20flat%20on%20soft%20cream%20linen%20fabric%20background%20minimal%20editorial%20photography%20gentle%20diffused%20natural%20lighting%20warm%20neutral%20tones%20clean%20Scandinavian%20aesthetic%20elegant%20fabric%20drape&width=400&height=400&seq=cat-grid-v2-sets&orientation=squarish",
      alt: "Sets products on itaobuyspreadsheet"
    },
    {
      name: "Underwear",
      url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
      image: "https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20basics%20neatly%20folded%20on%20warm%20beige%20textured%20surface%20minimal%20intimate%20product%20photography%20soft%20morning%20sunlight%20clean%20aesthetic%20gentle%20pastel%20undertones%20subtle%20fabric%20texture%20elegant%20presentation&width=400&height=400&seq=cat-grid-v2-underwear&orientation=squarish",
      alt: "Underwear products on itaobuyspreadsheet"
    },
    {
      name: "Jersey",
      url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
      image: "https://readdy.ai/api/search-image?query=Premium%20athletic%20jersey%20fabric%20closeup%20with%20visible%20texture%20and%20stitching%20detail%20on%20light%20neutral%20background%20minimal%20sportswear%20product%20photography%20soft%20studio%20lighting%20warm%20grey%20tones%20clean%20editorial%20style&width=400&height=400&seq=cat-grid-v2-jersey&orientation=squarish",
      alt: "Jersey products on itaobuyspreadsheet"
    },
    {
      name: "Accessories",
      url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
      image: "https://readdy.ai/api/search-image?query=Curated%20minimalist%20fashion%20accessories%20including%20watches%20and%20bracelets%20arranged%20on%20light%20travertine%20stone%20surface%20editorial%20photography%20soft%20natural%20window%20light%20warm%20neutral%20tones%20clean%20modern%20aesthetic&width=400&height=400&seq=cat-grid-v2-accessories&orientation=squarish",
      alt: "Accessories products on itaobuyspreadsheet"
    },
    {
      name: "Bags",
      url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
      image: "https://readdy.ai/api/search-image?query=Stylish%20canvas%20tote%20bag%20and%20woven%20straw%20bag%20on%20light%20wooden%20surface%20against%20sunlit%20wall%20editorial%20product%20photography%20warm%20natural%20daylight%20soft%20beige%20and%20sand%20tones%20clean%20composition%20gentle%20shadows&width=400&height=400&seq=cat-grid-v2-bags&orientation=squarish",
      alt: "Bags products on itaobuyspreadsheet"
    },
    {
      name: "Belts",
      url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
      image: "https://readdy.ai/api/search-image?query=Elegant%20braided%20leather%20and%20woven%20fabric%20belts%20curled%20artistically%20on%20cream%20textured%20surface%20minimal%20accessory%20photography%20soft%20natural%20side%20lighting%20warm%20cognac%20and%20tan%20tones%20clean%20editorial%20style&width=400&height=400&seq=cat-grid-v2-belts&orientation=squarish",
      alt: "Belts products on itaobuyspreadsheet"
    },
    {
      name: "Perfumes",
      url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
      image: "https://readdy.ai/api/search-image?query=Artisan%20glass%20perfume%20bottles%20with%20minimal%20labels%20arranged%20on%20cream%20marble%20surface%20with%20dried%20flowers%20soft%20natural%20lighting%20editorial%20beauty%20photography%20warm%20amber%20and%20rose%20tones%20clean%20refined%20composition&width=400&height=400&seq=cat-grid-v2-perfumes&orientation=squarish",
      alt: "Perfumes products on itaobuyspreadsheet"
    },
    {
      name: "Other Stuff",
      url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
      image: "https://readdy.ai/api/search-image?query=Eclectic%20lifestyle%20products%20including%20small%20home%20goods%20and%20gadgets%20arranged%20creatively%20on%20light%20surface%20minimal%20editorial%20flat%20lay%20photography%20soft%20natural%20lighting%20warm%20neutral%20tones%20clean%20aesthetic&width=400&height=400&seq=cat-grid-v2-other&orientation=squarish",
      alt: "Other products on itaobuyspreadsheet"
    }
  ];

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-left mb-12">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-light text-foreground-950">
            More Categories
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            Handpicked sourcing lists updated daily
          </p>
        </div>

        {/* Top 3 large cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-background-300/60 transition-all duration-300">
            <div className="relative h-52 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Tailored%20denim%20jacket%20draped%20casually%20on%20vintage%20wooden%20chair%20against%20sunlit%20whitewashed%20brick%20wall%20editorial%20fashion%20photography%20soft%20morning%20light%20warm%20neutral%20tones%20textile%20texture%20visible%20clean%20urban%20aesthetic&width=700&height=500&seq=cat-more-v2-jackets&orientation=landscape"
                alt="Jackets products on itaobuyspreadsheet"
                title="Jackets - ItaobuySpreadsheet"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 text-center">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">Jackets</h3>
              <p className="text-sm text-primary-500 font-medium mt-1">From $12.00</p>
              <a
                href="https://kaspreadsheet.com/search-914/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center w-4/5 mt-4 py-2.5 text-sm font-medium rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                View Products
              </a>
              <p className="text-xs text-foreground-400 mt-2">Links to kaspreadsheet.com</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-background-300/60 transition-all duration-300">
            <div className="relative h-52 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Lightweight%20linen%20trousers%20and%20tailored%20shorts%20draped%20over%20minimal%20oak%20stool%20near%20sunny%20window%20editorial%20fashion%20photography%20soft%20natural%20daylight%20warm%20sand%20and%20cream%20tones%20clean%20composition%20organic%20fabric%20folds&width=700&height=500&seq=cat-more-v2-pants&orientation=landscape"
                alt="Pants Shorts products on itaobuyspreadsheet"
                title="Pants Shorts - ItaobuySpreadsheet"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 text-center">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">Pants/Shorts</h3>
              <p className="text-sm text-primary-500 font-medium mt-1">From $12.00</p>
              <a
                href="https://kaspreadsheet.com/search-915/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center w-4/5 mt-4 py-2.5 text-sm font-medium rounded-full border border-foreground-300 text-foreground-700 hover:bg-foreground-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                View Products
              </a>
              <p className="text-xs text-foreground-400 mt-2">Links to kaspreadsheet.com</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-background-300/60 transition-all duration-300">
            <div className="relative h-52 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20straw%20fedora%20hat%20and%20classic%20baseball%20caps%20displayed%20on%20minimal%20wall%20hooks%20against%20warm%20clay%20painted%20wall%20editorial%20accessory%20photography%20soft%20afternoon%20light%20warm%20terracotta%20tones%20clean%20composition&width=700&height=500&seq=cat-more-v2-headwear&orientation=landscape"
                alt="Headwear products on itaobuyspreadsheet"
                title="Headwear - ItaobuySpreadsheet"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 text-center">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">Headwear</h3>
              <p className="text-sm text-primary-500 font-medium mt-1">From $12.00</p>
              <a
                href="https://kaspreadsheet.com/search-916/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center w-4/5 mt-4 py-2.5 text-sm font-medium rounded-full border border-foreground-300 text-foreground-700 hover:bg-foreground-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                View Products
              </a>
              <p className="text-xs text-foreground-400 mt-2">Links to kaspreadsheet.com</p>
            </div>
          </div>
        </div>

        {/* Bottom 8 small image cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mt-10">
          {smallCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-background-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.alt}
                  title={`${cat.name} - ItaobuySpreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              </div>
              <div className="px-3 py-3 text-center">
                <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}